import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import moment from "moment";

let delay = null;

class NotifList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datatable: this.props.datatable
    };
  }

  render() {
    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        name: "user_id",
        label: "User_id",
        options: {
          filter: false,
          display: false
        }
      },
      {
        label: "Issuperuser",
        name: "issuperuser",
        options: {
          filter: false,
          display: false
        }
      },
      {
        label: "Name",
        name: "name",
        options: {
          filter: true
        }
      },
      {
        label: "Email",
        name: "email",
        options: {
          filter: false
        }
      },
      {
        label: "Description",
        name: "description",
        options: {
          filter: true
        }
      },
      {
        label: "Activity",
        name: "activity",
        options: {
          filter: true,
          display: false
        }
      },
      {
        label: "IP Address",
        name: "ipaddress",
        options: {
          filter: true
        }
      },
      {
        label: "Date Time",
        name: "date_created",
        options: {
          filter: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return <div>{moment(value).format("DD-MM-YYYY HH:mm:ss")}</div>;
          }
        }
      },
      {
        label: "Location",
        name: "location",
        options: {
          filter: true,
          display: true
        }
      },
      {
        label: "Os",
        name: "os",
        options: {
          filter: false,
          display: false
        }
      }

      // {
      //   name: "Action",
      //   options: {
      //     filter: true,
      //     customBodyRender: (value, tableMeta, updateValue) => {
      //       let id = (tableMeta.rowData !== undefined) ? tableMeta.rowData[0]:0
      //       return (
      //         <div>
      //           <Button variant="outlined" color="secondary" onClick={() => this.props.handleDelete(id)}>
      //             Delete
      //           </Button>
      //           <Button variant="outlined" color="primary" onClick={()=>this.props.restate(tableMeta.rowData)} >
      //             Update
      //           </Button>
      //         </div>
      //       );
      //     }
      //   }
      // }
    ];

    const options = {
      filter: false,
      //filterType: "dropdown",
      selectableRows: false,
      responsive: "simple",
      search: true,
      textLabels: {
        body: {
          noMatch: this.props.loader
            ? "Searching..."
            : "Sorry, no matching records found"
        }
      },
      //searchText: this.props.searchText,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.props.handleSearch(
              tableState.rowsPerPage,
              tableState.page,
              tableState.searchText
            );
            break;
          case "changeRowsPerPage":
            this.props.handleSearch(
              tableState.rowsPerPage,
              tableState.page,
              tableState.searchText
            );
            break;
          case "search":
            if (delay !== null) {
              clearTimeout(delay);
            }
            delay = setTimeout(async () => {
              let searchKeyword = tableState.searchText
                ? tableState.searchText
                : "";
              await this.props.handleKeyword(searchKeyword);
              tableState.searchText = this.props.keyword;
            }, 3000);
            break;
          case "propsUpdate":
            if (this.props.searchCheck) {
              this.props.handleCheckSearch();
              tableState.page = 0;
              tableState.rowsPerPage = 10;
            }
            break;
          default:
            break;
        }
      },
      serverSide: true,
      count: this.props.totalData
    };

    console.log(this.props.datatable);
    return (
      <Grid item xs={12}>
        <Grid item xs={12}>
          <MUIDataTable
            title={"Log Activity"}
            data={this.props.datatable}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
    );
  }
}

export default NotifList;
